var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIc33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "20.354mm",
    height: "12.2554mm",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 20354 12255.4",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M17740.3 12255.4l-17740.3 0 0 -9064.7 17740.3 0 0 9064.7zm-17518.1 -222.3l17295.9 0 0 -8620.1 -17295.9 0 0 8620.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M9546.2 2545.2l-190.5 -637.6 -965.8 0 -187.8 637.6 -359.9 0 817.6 -2545.2 444.5 0 812.3 2545.3 -370.4 -0.1zm-1079.4 -923.4l793.7 0 -396.9 -1322.9 -396.8 1322.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M20087.2 7522.1c167.5,131.2 265.4,332.4 265.4,545.3 0,11.3 -0.3,22.8 -0.8,33.9 1.3,19 2.2,38.3 2.2,57.3 0,217.8 -98.1,424.2 -266.9,561.9 -195.4,128.7 -424.9,197.5 -659,197.5 -21.1,0 -42.3,-0.6 -63.2,-1.6l-680 0 0 -2547.9 1383.7 0 -42.3 288.4 -992.2 0 0 669.4 336 0c22.3,-1.4 44.8,-2.1 67.2,-2.1 231.3,0 457.8,68.9 649.9,197.7l0 0.2zm-264.5 997.4c99.9,-89.9 157,-218 157,-352.3 0,-19.3 -1.2,-38.7 -3.5,-57.9 1.4,-14.9 2.1,-30.1 2.1,-45.2 0,-132.3 -56.8,-258.5 -155.7,-346.3 -115.4,-77.2 -251.5,-118.4 -390.4,-118.4 -17.1,0 -34.3,0.7 -51.3,1.9l-346.7 0.1 0 1034.5 351.9 0.1c14.3,0.7 28.9,1.2 43.2,1.2 138.1,0 273.3,-41 388.1,-117.8l5.3 0.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M7032.6 8995.8l-193.1 -640.3 -963.1 0 -193.2 640.3 -354.5 0 817.6 -2545.3 441.8 0 820.2 2545.3 -375.7 0zm-1058.3 -923.5l793.7 0 -394.2 -1322.9 -399.5 1322.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "black",
    fillRule: "nonzero",
    d: "M12133.8 7598.8c167.5,130.1 265.7,330.7 265.7,543 0,12.9 -0.4,26.1 -1.1,39 1.5,19.3 2.3,38.9 2.3,58.3 0,216.8 -98.2,422.1 -267,558.1 -196.9,130.5 -428.4,200.3 -664.7,200.3 -21.8,0 -43.8,-0.6 -65.4,-1.8l-672.1 0.1 0 -2548 1386.4 0 -45 288.4 -989.5 0 0 672.1 336 0c24.5,-1.7 49.6,-2.5 74.2,-2.5 227.6,0 450.5,67.2 640.2,192.8l0 0.2zm-264.5 1000.1c95.9,-91.9 150.2,-219 150.2,-351.8 0,-15 -0.7,-30.2 -2.1,-45.1 1.5,-15.2 2.3,-30.5 2.3,-45.7 0,-132.5 -55.5,-259 -153,-348.6 -123,-87.9 -270.6,-135.3 -421.8,-135.3 -7.5,0 -15.3,0.2 -22.7,0.4l-338.7 0.1 0 1034.5 351.9 0c15.9,1 32,1.5 48,1.5 135.5,0 268.4,-38.2 383.2,-110.1l2.7 0.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "black",
    fillRule: "nonzero",
    points: "8950.8,7649 9525,8366.1 9178.4,8366.1 8770.9,7799.9 8358.1,8366.1 8030.1,8366.1 8609.5,7672.8 8096.2,7027.2 8437.6,7027.2 8784.2,7516.8 9136.1,7027.2 9464.1,7027.2 "
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc33);
export default __webpack_public_path__ + "static/media/ic_3_3.6d374d1d9d8853586b0edaa7a0a6bc0b.svg";
export { ForwardRef as ReactComponent };